module.exports = __webpack_public_path__ + "media/images/tyre-stack-430ab7c1c50b802e66c13f8bd39616e1.svg";